import React from 'react';
import { useI18n } from '../i18n/I18nProvider';

export function shiftWeek(start: string, weeks: number) {
  const date = new Date(`${start}T12:00:00`);
  date.setDate(date.getDate() + weeks * 7);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
export function currentMonday() {
  const date = new Date();
  date.setDate(date.getDate() - (date.getDay() + 6) % 7);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
function weekNumber(start: string) {
  const thursday = new Date(`${start}T12:00:00Z`);
  thursday.setUTCDate(thursday.getUTCDate() + 3);
  return Math.ceil(((thursday.getTime() - Date.UTC(thursday.getUTCFullYear(), 0, 1)) / 86400000 + 1) / 7);
}
export function OptimizerWeekSelect({ value, disabled, onChange }: { value: string; disabled: boolean; onChange: (value: string) => void }) {
  const { t, language } = useI18n();
  const today = currentMonday();
  const format = (date: Date) => date.toLocaleDateString(language === 'de' ? 'de-AT' : 'en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const caption = (start: string) => {
    const end = new Date(`${start}T12:00:00`); end.setDate(end.getDate() + 4);
    return `${t('optimizer.weekNumber', { number: weekNumber(start) })} · ${format(new Date(`${start}T12:00:00`))} – ${format(end)}`;
  };
  return <div className="optimizer-week">
    <label className="admin-form-label" htmlFor="optimizer-week">{t('optimizer.week')}</label>
    <div className="optimizer-week-controls">
      <button type="button" className="btn btn-neutral" disabled={disabled} aria-label={t('optimizer.previousWeek')} onClick={() => onChange(shiftWeek(value, -1))}>‹</button>
      <select autoFocus id="optimizer-week" className="form-control" value={value} disabled={disabled} onChange={e => onChange(e.target.value)}>
        {Array.from({ length: 105 }, (_, i) => shiftWeek(value, i - 52)).map(start => <option key={start} value={start}>{caption(start)}</option>)}
      </select>
      <button type="button" className="btn btn-neutral" disabled={disabled} aria-label={t('optimizer.nextWeek')} onClick={() => onChange(shiftWeek(value, 1))}>›</button>
    </div>
    <div className="mt-2 flex gap-2">
      <button type="button" className="btn btn-ghost" disabled={disabled || value === today} onClick={() => onChange(today)}>{t('optimizer.thisWeek')}</button>
      <button type="button" className="btn btn-ghost" disabled={disabled || value === shiftWeek(today, 1)} onClick={() => onChange(shiftWeek(today, 1))}>{t('optimizer.nextWeek')}</button>
    </div>
  </div>;
}
